export default "__VITE_ASSET__B3xw5aXD__"